// extracted by mini-css-extract-plugin
module.exports = {"container":"Section10_container__4UXiS","form":"Section10_form__EAL3C"};